<template>
  <tv-page title="模板" :loading="loading" :class="_.page">
    <template v-if="!loading">
      <div :class="_.hd">头部</div>
    </template>
  </tv-page>
</template>

<script>
  import Vue from 'vue'
  import { Track } from '@/utils'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        // 埋点页面名称
        name: '模板',
      })),
    ],

    data: () => ({
      // 页面加载状态
      loading: true,
    }),

    mounted() {
      this.loading = false
    },
  })
</script>

<style lang="scss" module>
  .page {
    background-color: #1f2733;
  }

  .hd {
    color: red;
  }
</style>
